const env = {
    domainUrl: process.env.NEXT_PUBLIC_DOMAIN_URL,
    // Where the ai-mail proxies (pages/api/gmail/*, pages/api/outlook/*) send
    // requests. Unset on dev / prod: there ONE gateway serves ai-flows and
    // ai-mail, so they use domainUrl. Set it in .env.local when ai-mail runs on
    // its own port (http://localhost:4000) — it replaces the per-proxy
    // `clusterEnv === 'LOCAL'` switches, which never covered LOCAL_PROD.
    mailDomainUrl: process.env.NEXT_PUBLIC_MAIL_DOMAIN_URL,

    reportingApiUrl: process.env.NEXT_PUBLIC_DOMAIN_URL,
    s3RealtorUrl: process.env.NEXT_PUBLIC_S3_REALTOR_URL,
    clusterEnv: process.env.NEXT_PUBLIC_NODE_ENV,
    googleAnalyticsID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
    // ttlExpiryInHours: process.env.NEXT_PUBLIC_TTL_EXPIRY_IN_HOURS
    // accountId: process.env.NEXT_PUBLIC_ACCOUNT_ID,
    // socketUrl: process.env.NEXT_PUBLIC_SOCKET_URL,
    // orgName: process.env.NEXT_PUBLIC_ORG_NAME,
}

export default env